import { combineReducers } from "redux";
import { reducer as bookReducer } from "./books/reducer";
import { reducer as filtersReducer } from "./filters/reducer";



const rootReducer = combineReducers({
  books: bookReducer,
  filters: filtersReducer,
});

export default rootReducer;
